import React from 'react';
import { Image } from 'react-bootstrap';
import { PopupTip } from '@adaptis/flow-components';
import { tips } from '../PopupTips/tips';
import _ from 'lodash';
import { INoSubLimitsBanner2Props } from './NoSubLimitsBanner2.types';

import './NoSubLimitsBanner2.scss';

export default function NoSubLimitsBanner2(props: INoSubLimitsBanner2Props) {
  const tip = props.tipName ? _.get(tips, props.tipName) : undefined;

  return (
    <div
      data-testid='NoSubLimitsBanner2'
      className='flc_no-sub-limits-banner2 pb-4'
      style={{ backgroundImage: `url('${props.heroImage}')` }}>
      <div className='tag-line'>{props.tagLine}</div>
      <div className='paragraph'>{props.paragraph}<PopupTip className='ms-3' tip={tip} label="Read more."></PopupTip> <PopupTip className='ms-1' tip={tip}></PopupTip></div>
      {/* <div className='sublimit-svg-container'>
        <Image src={props.noSublimitSVG} />
      </div> */}
      {/* <div className='tip-label-container'>
        <PopupTip className='ms-3' tip={tip}></PopupTip>
        <div className='tip-label'>{props.tipLabel}</div>
      </div> */}
    </div>
  );
}
